import React, { useEffect, useRef, useState } from "react";
import { Col, Row } from "react-bootstrap";
import CustomFormInput from "../components/CustomFormInput";
import { useNavigate } from "react-router-dom";
import { validate } from "./LoginSchema";
import SingleError from "../helper/SingleError";
import { loginAdmin } from "../controller";
import { encryptAndStoreLoc } from "../helper/localStorage";
import { requestHandler } from '../helper';
import { toast } from 'react-toastify';
import Loader from "../components/Loader";

function Login() {
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);
  const ref = useRef(null);
  const togglePasswordVisibility = () => {
    setIsPasswordVisible(!isPasswordVisible);
  };

  const initialValues = {
    email: "",
    password: "",
  };

  const navigate = useNavigate();
  const [values, setValues] = useState(initialValues);
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [submitCount, setSubmitCount] = useState(0);

  const handleChange = (e) => {
    const { name, value, checked, type } = e.target;
    let newValue = type === "checkbox" ? checked : value;
    if (submitCount > 0) {
      let validationErrors = validate({ ...values, [name]: newValue });
      setErrors(validationErrors);
      if (Object.keys(validationErrors).length === 0) {
        delete errors[name];
      }
    }
    setValues((prevValues) => ({
      ...prevValues,
      [name]: newValue,
    }));
  }

  useEffect(() => {
    document.title = "Always Outdoors| Login";
    //eslint-disable-next-line
  }, [window.location.pathname])

  useEffect(() => {
    const callback = (event) => {
      if (event.key === 'Enter') {
        event.preventDefault();
        ref.current.click();
      }
    };
    document.addEventListener('keydown', callback);
    return () => {
      document.removeEventListener('keydown', callback);
    };
  }, []);


  const handleSubmit = async (e) => {
    const updatedValues = { ...values };
    setSubmitCount(prevCount => prevCount + 1);
    const validationErrors = validate(updatedValues);
    setErrors(validationErrors);
    if (Object.keys(validationErrors).length === 0) {
      await requestHandler(
        async () => await loginAdmin(updatedValues),
        setLoading,
        (res) => {
          toast.success(res.message);
          encryptAndStoreLoc("token", res.data.token);
          encryptAndStoreLoc("email", res.data.email);
          encryptAndStoreLoc("firstName", res.data.firstName);
          encryptAndStoreLoc("lastName", res.data.lastName);
          encryptAndStoreLoc("role", res.data.role);
          encryptAndStoreLoc("imageURL", res.data.imageURL);
          navigate("/dashboard");
        },
        () => {
          localStorage.removeItem("token")
        }
      )
    }
  }
  return (
    <>
      {loading && <Loader />}
      <div className="login-wrapper">
        <div className="container">
          <Row className="justify-content-center">
            <Col xxl={5} xl={6} lg={7} md={9}>
              <div className="login-card">
                <div className="login-logo">
                  <img
                    src="/images/svg/logo.svg"
                    className="img-fluid"
                    alt="logo"
                  />
                </div>
                <h4>Login</h4>
                <p>Enter your credential to access admin panel</p>
                <CustomFormInput
                  type="email"
                  label="Email Address"
                  placeholder="Enter your email"
                  id="email"
                  value={values.email}
                  onChange={handleChange}
                  name="email"
                />
                <SingleError error={errors?.email} />
                <div className="position-relative">
                  <CustomFormInput
                    type={isPasswordVisible ? "text" : "password"}
                    label="Password"
                    placeholder="Enter your password"
                    id="password"
                    value={values.password}
                    name='password'
                    onChange={handleChange}
                    className="password-input"
                  />
                  <span className="password-icon" onClick={togglePasswordVisibility}>
                    {isPasswordVisible ? <img src="/images/svg/eye-slash.svg" alt="icon" /> : <img src="/images/svg/eye.svg" alt="icon" />}
                  </span>
                  <SingleError error={errors?.password} />
                </div>
                {/* <div className="text-end mb-sm-4 mb-3">
                  <Link to="/reset-password" className="text-primary fs-14 fw-500">Forgot password?</Link>
                </div> */}
                <button className="btn btn-primary w-100 mt-1" ref={ref} type='submit' onClick={handleSubmit}>
                  Secure Login
                </button>
              </div>
            </Col>
          </Row>
        </div>
      </div>
    </>
  );

}

export default Login;
